import { render, staticRenderFns } from "./CustomCommentItem.vue?vue&type=template&id=6c0a0e03&"
import script from "./CustomCommentItem.vue?vue&type=script&lang=js&"
export * from "./CustomCommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports